<h6>Selecciona el tipo de envío</h6>
<div class="flex">
  <app-boton-acceso [icono]="'#hs-send'" [accionBoton]="'Crear Envío'" [tituloBoton]="'Envío estándar'" [texto]="'Dirigido a empleados'" [id]="'ESTÁNDAR'" (click)="selectTipoSubida('estándar')"></app-boton-acceso>
  <app-boton-acceso [icono]="'#hs-send-universal'" [accionBoton]="'Crear Envío'" [tituloBoton]="'Envío universal'" [texto]="'Dirigido a empleados y no empleados'" [id]="'MASIVA'" (click)="selectTipoSubida('masiva')"></app-boton-acceso>
</div>
